/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getUserContactByUserId } from '../fn/user-contact-controller/get-user-contact-by-user-id';
import { GetUserContactByUserId$Params } from '../fn/user-contact-controller/get-user-contact-by-user-id';
import { GetUserContactResponseDto } from '../models/get-user-contact-response-dto';

@Injectable({ providedIn: 'root' })
export class UserContactControllerApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getUserContactByUserId()` */
  static readonly GetUserContactByUserIdPath = '/v2/users/{user_id}/contact';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getUserContactByUserId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserContactByUserId$Response(
    params: GetUserContactByUserId$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetUserContactResponseDto>> {
    return getUserContactByUserId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getUserContactByUserId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getUserContactByUserId(
    params: GetUserContactByUserId$Params,
    context?: HttpContext
  ): Observable<GetUserContactResponseDto> {
    return this.getUserContactByUserId$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetUserContactResponseDto>): GetUserContactResponseDto => r.body)
    );
  }
}
